var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.2812 1.5H0.907203C1.0562 1.94 1.3062 2.354 1.6572 2.705L2.7832 3.83081L7.5392 8.586C7.82868 8.87572 8.17241 9.10556 8.55076 9.26237C8.92911 9.41918 9.33465 9.4999 9.7442 9.4999C10.1538 9.4999 10.5593 9.41918 10.9376 9.26237C11.316 9.10556 11.6597 8.87572 11.9492 8.586L16.7832 3.75282L17.8312 2.705C18.1812 2.354 18.4312 1.94 18.5802 1.5H16.2072L15.7072 2L10.5352 7.172C10.4313 7.27598 10.3079 7.35847 10.1721 7.41475C10.0363 7.47103 9.89071 7.5 9.7437 7.5C9.5967 7.5 9.45113 7.47103 9.31532 7.41475C9.17951 7.35847 9.05612 7.27598 8.9522 7.172L3.78112 2L3.2812 1.5Z",
    fill: "#00214D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.7832 12V3.83081L1.6572 2.705C1.3062 2.354 1.0562 1.94 0.907203 1.5H3.2812L3.78112 2H15.7072L16.2072 1.5H18.5802C18.4312 1.94 18.1812 2.354 17.8312 2.705L16.7832 3.75282V8H18.7832V2C18.7832 0.9 17.8832 0 16.7832 0H2.7832C1.6832 0 0.783203 0.9 0.783203 2V12C0.783203 13.1 1.6832 14 2.7832 14H12.7832V12H2.7832Z",
    fill: "#00214D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7832 11V9.99C17.7806 9.72652 17.674 9.47473 17.4868 9.28935C17.2995 9.10397 17.0467 8.99999 16.7832 9C16.2272 9 15.7832 9.444 15.7832 9.99V11H14.7832C14.518 11 14.2636 11.1054 14.0761 11.2929C13.8886 11.4804 13.7832 11.7348 13.7832 12C13.7832 12.2652 13.8886 12.5196 14.0761 12.7071C14.2636 12.8946 14.518 13 14.7832 13H15.7832V14.01C15.7858 14.2735 15.8924 14.5253 16.0796 14.7107C16.2669 14.896 16.5197 15 16.7832 15C17.3392 15 17.7832 14.556 17.7832 14.01V13H18.7832C19.0484 13 19.3028 12.8946 19.4903 12.7071C19.6778 12.5196 19.7832 12.2652 19.7832 12C19.7832 11.7348 19.6778 11.4804 19.4903 11.2929C19.3028 11.1054 19.0484 11 18.7832 11H17.7832Z",
    fill: "#00214D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailPlus);
export default __webpack_public_path__ + "static/media/emailPlus.fca6b933a11fa8f36a4f5f63a57a8407.svg";
export { ForwardRef as ReactComponent };